import { Box, DialogTitle, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { RowField } from "../../../salaries/payslips/PayslipsTable";
import { Payslips } from "../../../salaries/payslips/Payslips";
import { SearchFilter } from "../../../../common/components/functional/FilterSearchField/FilterSearchField";

interface Props {
  talentId: string;
  isReadOnly: boolean;
}

const PayslipOverview = ({ talentId, isReadOnly }: Props) => {
  const { t } = useTranslation();

  const overviewSearchFilter: SearchFilter[] = useMemo(() => {
    return [
      {
        name: "talentIds",
        value: [talentId],
      },
    ];
  }, [talentId]);

  // TODO refactor?
  // Widths need to match widths in rowHelpers.tsx
  const rowFields: RowField[] = [
    { name: "salaryDate", width: "90px" },
    { name: "payer", width: "180px" },
    { name: "valueDate", width: "90px" },
    { name: "payslipNumber", width: "70px" },
    { name: "payslipPeriodStart", width: "90px" },
    { name: "payslipPeriodEnd", width: "90px" },
    { name: "incomeNet", width: "80px" },
    { name: "incomeGross", width: "80px" },
    { name: "taxWithholding", width: "90px" },
    { name: "pensionInsurance", width: "80px" },
    { name: "unemploymentInsurance", width: "80px" },
    { name: "taxExempt", width: "80px" },
    {
      name: "totalPayment",
      width: "80px",
    },
    {
      name: "status",
      width: "150px",
    },
  ];

  return (
    <Box
      sx={{
        background: "#FFFFFF",
        padding: "0px 0px 16px 16px",
        borderRadius: "12px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          padding: "16px 16px 0px 8px",
        }}
      >
        <DialogTitle
          sx={{
            paddingLeft: "0px",
            background: "#FFFFFF",
            borderTopLeftRadius: "8px",
            borderTopRightRadius: "8px",
            fontSize: "14px",
          }}
        >
          <Typography
            variant="header"
            sx={{
              fontWeight: 600,
            }}
          >
            {t("talentProfile:payslip").toUpperCase()}
          </Typography>
        </DialogTitle>
      </Box>

      <Payslips
        rowFields={rowFields}
        filters={overviewSearchFilter}
        addPayslip={!isReadOnly}
        talentId={talentId}
        canEditPayslipDates={!isReadOnly}
        showTalentView
        tableContainerSx={{
          maxHeight: "55vh",
          overflowY: "auto",
          scrollbarWidth: "none",
        }}
      />
    </Box>
  );
};

export default PayslipOverview;
